// src/billing/RevenueCatPaywall.js
import { Purchases } from "@revenuecat/purchases-capacitor";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function getCurrentOffering({ retries = 2, delayMs = 500 } = {}) {
    let lastErr = null;
  
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        // ✅ Capacitor returns offerings directly, not wrapped in { offerings: ... }
        const offerings = await Purchases.getOfferings();
        return offerings.current || null;
      } catch (e) {
        lastErr = e;
  
        // Better logging (Capacitor errors often stringify to {})
        console.error("[RevenueCat] getOfferings error:", e);
        try {
          console.error(
            "[RevenueCat] getOfferings error props:",
            Object.getOwnPropertyNames(e),
            "message:",
            e?.message
          );
        } catch (_) {}
  
        if (attempt < retries) await sleep(delayMs);
      }
    }
  
    throw lastErr;
  }

//takes a package from the fetched Offering and purchases the underlying product with Apple/Google
export async function purchasePackage(aPackage) {
    const { customerInfo } = await Purchases.purchasePackage({ aPackage });
    return customerInfo;
  }

export async function restorePurchases() {
  const { customerInfo } = await Purchases.restorePurchases();
  return customerInfo;
}